export function debounce(fn, time) {
  let timeoutId;

  function wrapper(...args) {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => {
      timeoutId = null;
      fn(...args);
    }, time);
  }

  return wrapper;
}

export function noop() {}
